// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import React, { lazy } from 'react';
import { Navigate } from 'react-router-dom';
import Loadable from '../layouts/full/shared/loadable/Loadable';
// import DashboardLoadable from 'src/layouts/full/shared/loadable/DashboardLoadable';

/* ***Layouts**** */
const FullLayout = Loadable(lazy(() => import('../layouts/full/FullLayout')));
const BlankLayout = Loadable(lazy(() => import('../layouts/blank/BlankLayout')));

/* **** SDC Pages***** */
const Login = lazy(() => import( '../SDC_pages/auth/login/Login'));
const ForgotPassword = lazy(() => import( '../SDC_pages/auth/forget_password/ForgotPassword'));
const NotFound = lazy(() => import( '../SDC_pages/error/Error'));

const SDCDasboard = Loadable(lazy(() => import( '../SDC_pages/dashboard/Dashboard')));
const Users = Loadable(lazy(() => import( '../SDC_pages/users/Users')));
const UserDetail = Loadable(lazy(() => import( '../SDC_pages/user_details/UserDetails')));
const ProDetail = Loadable(lazy(() => import( '../SDC_pages/professional_details/ProfessionalDetails')));
const Requests = Loadable(lazy(() => import( '../SDC_pages/requests/Requests')));
const RequestDetail = Loadable(lazy(() => import( '../SDC_pages/request_details/RequestDetails')));

const Fields = Loadable(lazy(() => import( '../SDC_pages/fields/Fields')));
const Sessions = Loadable(lazy(() => import( '../SDC_pages/sessions/Sessions')));
const SessionsLink = Loadable(lazy(() => import( '../SDC_pages/link_sessions_to_fields/LinkSessionToField')));
const RanksUpdate = Loadable(lazy(() => import( '../SDC_pages/ranks_update/RanksUpdate')));
const RankSingleUserUpdate = Loadable(lazy(() => import( '../SDC_pages/ranks_update/RankUserUpdate')));
const Club = Loadable(lazy(() => import( '../SDC_pages/clup/Club')));
const Ranks = Loadable(lazy(() => import( '../SDC_pages/ranks/Ranks')));
const Reports = Loadable(lazy(() => import( '../SDC_pages/reports/Reports')));
const Documents = Loadable(lazy(() => import( '../SDC_pages/documents/Documents')));
const DocumentsLink = Loadable(lazy(() => import( '../SDC_pages/link_document_to_fields/LinkDocumentToField')));
const Regions = Loadable(lazy(() => import( '../SDC_pages/regions/Regions')));
const Districts = Loadable(lazy(() => import( '../SDC_pages/districts/Districts')));
const CollectionRequests = Loadable(lazy(() => import( '../SDC_pages/collection_requests/CollectionRequests')));
const Gym = Loadable(lazy(() => import( '../SDC_pages/gym/Gym')));
const Advertisements = Loadable(lazy(() => import( '../SDC_pages/advertisements/Advertisements')));
const AdDetails = Loadable(lazy(() => import( '../SDC_pages/advertisements/add_details/AdDetails')));

const BlockedUsers = Loadable(lazy(() => import( '../SDC_pages/blocked_users/BlockedUsers')));
const BlockedUserDetail = Loadable(lazy(() => import( '../SDC_pages/blocked_users/BlockedUserDetails')));
const BlockedPosts = Loadable(lazy(() => import( '../SDC_pages/blocked_posts/BlockedPosts')));

const ReservationsStates = Loadable(lazy(() => import( '../SDC_pages/statistics/ReservationsStates')));
const UsersStates = Loadable(lazy(() => import( '../SDC_pages/statistics/UsersStates')));
const ClubStates = Loadable(lazy(() => import( '../SDC_pages/statistics/ClubStates')));

const RejectUserReasons = Loadable(lazy(() => import( '../SDC_pages/general_settings/reject_user_reasons/RejectUserReasons')));
const Settings = Loadable(lazy(() => import( '../SDC_pages/settings/GeneralSettings')));

const Home = lazy(() => import( 'src/landingpage/pages/Home'));
const Services = lazy(() => import( 'src/landingpage/pages/service/Service'));
const Blogs = lazy(() => import( 'src/landingpage/pages/blog/Blogs'));
const BlogDetails = lazy(() => import( 'src/landingpage/pages/blog_details/BlogDetails'));
const BlogCategory = lazy(() => import( 'src/landingpage/pages/blog_categories/BlogsCat'));
const Contact = lazy(() => import( 'src/landingpage/pages/contact/ContactUs'));

const TermsOfUse = lazy(() => import( 'src/landingpage/pages/Instruction_pages/TermsOfUse'));
const TermsOfDelete = lazy(() => import( 'src/landingpage/pages/Instruction_pages/DeleteAccountInstruction'));
const AuthLayout = lazy(() => import( 'src/layouts/auth/AuthLayout'));


const Router = [
  {
    path: '/',
    element: <BlankLayout />,
    children: [

      // home page routes
      { path: '/', element: <Navigate to="/home" /> },
      { path: '/home', exact: true, element: <Home /> },
      { path: '/home/service/:id', exact: true, element: <Services /> },
      { path: '/home/contact', exact: true, element: <Contact /> },
      { path: '/home/blogs', exact: true, element: <Blogs /> },
      { path: '/home/blog-details/:id', exact: true, element: <BlogDetails /> },
      { path: '/home/blog-category/:id', exact: true, element: <BlogCategory /> },
      { path: '/sdc-terms-of-use', exact: true, element: <TermsOfUse /> },
      { path: '/sdc-delete-account', exact: true, element: <TermsOfDelete /> },
    ],
  },
  {
    path: '/',
    element: <FullLayout />,
    children: [

      // Acc routes
      { path: '/admin/dashboard', exact: true, element: <SDCDasboard /> },
      { path: '/admin/users', exact: true, element: <Users /> },
      { path: '/admin/users/user_detail/:id', element: <UserDetail /> },
      { path: '/admin/users/pro_detail/:id', element: <ProDetail /> },
      { path: '/admin/requests', exact: true, element: <Requests /> },
      { path: '/admin/requests/req_detail/:id', element: <RequestDetail /> },
      
      { path: '/admin/fields', exact: true, element: <Fields /> },
      { path: '/admin/sessions', exact: true, element: <Sessions /> },
      { path: '/admin/sessions_link', exact: true, element: <SessionsLink /> },
      { path: '/admin/ranks_update', exact: true, element: <RanksUpdate /> },
      { path: '/admin/rank_user_update/:id', exact: true, element: <RankSingleUserUpdate /> },
      { path: '/admin/club', exact: true, element: <Club /> },
      { path: '/admin/ranks', exact: true, element: <Ranks /> },
      { path: '/admin/reports', exact: true, element: <Reports /> },
      { path: '/admin/documents', exact: true, element: <Documents /> },
      { path: '/admin/documents', exact: true, element: <Documents /> },
      { path: '/admin/documents_link', exact: true, element: <DocumentsLink /> },
      { path: '/admin/regions', exact: true, element: <Regions /> },
      { path: '/admin/districts', exact: true, element: <Districts /> },
      { path: '/admin/collection_requests', exact: true, element: <CollectionRequests /> },
      { path: '/admin/gym', exact: true, element: <Gym /> },
      { path: '/admin/advertisements', exact: true, element: <Advertisements /> },
      { path: '/admin/add_details/:id', exact: true, element: <AdDetails /> },

      { path: '/admin/reservations_states', exact: true, element: <ReservationsStates /> },
      { path: '/admin/users_states', exact: true, element: <UsersStates /> },
      { path: '/admin/club_states', exact: true, element: <ClubStates /> },
      
      { path: '/admin/blocked_users', exact: true, element: <BlockedUsers /> },
      { path: '/admin/blocked_users/details/:id', exact: true, element: <BlockedUserDetail /> },
      { path: '/admin/blocked_posts', exact: true, element: <BlockedPosts /> },

      { path: '/admin/settings', exact: true, element: <Settings /> },
      { path: '/admin/reject_reasons', exact: true, element: <RejectUserReasons /> },
    ],
  },
  {
    path: '/',
    element: <AuthLayout />,
    children: [

      // Acc routes
      { path: '/auth/login', element: <Login /> },
      { path: '/auth/forgot_password', element: <ForgotPassword /> },
      { path: '*', element: <NotFound/>},

    ],
  },

];

export default Router;
